/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ToolPencilLineIcon16Solid = forwardRef('ToolPencilLineIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 11.414V13.5a.5.5 0 0 0 .5.5h2.086a1 1 0 0 0 .707-.293l7.145-7.145-3-3-7.145 7.145a1 1 0 0 0-.293.707Z" }),
        React.createElement("path", { d: "m13.58 4.42-1.07 1.07-3-3 1.07-1.07a1.3 1.3 0 0 1 1.84 0l1.16 1.16a1.3 1.3 0 0 1 0 1.84Z" }),
        React.createElement("path", { d: "M8.5 12a1 1 0 1 0 0 2H15a1 1 0 1 0 0-2H8.5Z" })));
});
